export default [
  {
    path: '/login',
    name: 'login',
    component: () => import('@/views/login/Login')
  },
  {
    path: '/auth/:id',
    name: 'auth',
    component: () => import('@/views/login/Auth')
  }
]
